import { Address } from './address.types';
import { Wallet } from './wallet.types';

enum UserStatus {
    registered = 'registered',
    profile = 'profile',
    bank = 'bank',
    upload = 'upload',
    accept = 'accept',
    ban = 'ban',
    deleted = 'deleted',
    reject = 'reject',
}

type User = {
    id?: number;
    name: string;
    family: string;
    phone: string;
    avatar: string;
    avatar_color: string;
    type: string;
    status: UserStatus;
    addresses: Address;
    twoverify: boolean;
    secret_key: string;
    // wallets: Record<string, Wallet>;
    opts?: { [key: string]: any };
    referral?: string;
    referral_code?: string;
    referral_locked?: boolean;
    account?: string;
    reffered?: string;
    father: string;
    birth: string;
    national: string;
    passport: string;
    telegram_id: string;
    email: string;
    permissions: Array<string>;
    comments: string;
};

type UpdateUser = {
    signatures: Array<any>;
    type: any;
} & Pick<
    User,
    | 'name'
    | 'family'
    | 'phone'
    | 'status'
    | 'father'
    | 'birth'
    | 'national'
    | 'passport'
    | 'telegram_id'
    | 'email'
> &
    Pick<Address, 'address' | 'city' | 'telephone' | 'postal'>;

export { UserStatus };
export type { User, UpdateUser };
